import React, { useEffect, useState } from 'react'
import {
  Button,
  Form,
  Modal,
  Checkbox,
  FormField,
  Icon,
  Dropdown,
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RefreshUserCustomersList } from '../../../../../redux/actions/customer'
import styles from './customer-modal.module.css'
import StatusDialog from '../../../../status-dialog'
import IntelMsg from '../../../../ItelMsg/index'
import {
  GetSFDCustomerTemplate,
  saveCustomer,
} from '../../../../../services/customer/index'
import ValidatorGenerator from '../../../../../services/configuration-template/validatores'
const AddCustomer = ({ show, setShow }) => {
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [creationData, setCreationData] = useState([])
  const [selectedActivity, setSelectedActivity] = useState()
  const [activityIsEmpty, setActivityIsEmpty] = useState(true)

  const [selectedCustomer, setSelectedCustomer] = useState('default')
  const { register, errors, handleSubmit, setValue, clearErrors } = useForm()
  const { t } = useTranslation()
  const [customerTypes, setCustomerTypes] = useState([
    { value: 'SFDA Company', text: 'SFDA Company' },
    { value: 'default', text: 'Customer' },
  ])
  const companyActivities = [
    { value: 'STORE', text: 'STORE' },
    { value: 'TRANSPORT', text: 'TRANSPORT' },
    { value: 'STORE_TRANSPORT', text: 'STORE_TRANSPORT' },
  ]
  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const handleClose = () => {
    setShow(false)
    setCreationData([])
    setDisableSubmit(true)
  }
  useEffect(() => {
    if (productName === 'tank') {
      setCustomerTypes([{ value: 'default', text: 'Customer' }])
    }
  }, [])

  useEffect(() => {
    if (show && productName === 'tank') {
      GetSFDCustomerTemplate('default', productName).then((configData) => {
        if (configData['sfda attributes map']) {
          const creationMap = JSON.parse(configData['sfda attributes map'])
          creationMap.sort(sorting)
          setCreationData([])
          setCreationData(creationMap)
        }
        if (configData['default attributes map']) {
          const defaultCreationMap = JSON.parse(
            configData['default attributes map'],
          )
          defaultCreationMap.sort(sorting)
          setCreationData([])
          setCreationData(defaultCreationMap)
        }
      })
    }
  }, [show])
  const dispatch = useDispatch()
  const createTextField = (columnData) => {
    const validate = ValidatorGenerator(columnData['validator type'])
    if (columnData['input name'] === 'sfdaActivity') {
      return (
        <Form.Field error={errors[columnData['input name']]}>
          <strong>
            <IntelMsg id={columnData['label ID']} />
          </strong>
          <input
            ref={(ref) => {
              register(ref, { validate })
            }}
            type={columnData['input type'] === 'NUMERIC' ? 'number' : 'text'}
            name={columnData['input name']}
            disabled
            value={columnData.value}
            placeholder={t(columnData.placeholder)}
          />
          {columnData['validator type'] !== 'noValidation' ? (
            <small style={{ color: 'red' }}>
              {errors[columnData['input name']] ? (
                <IntelMsg id={columnData['err msg']} />
              ) : (
                '**'
              )}
            </small>
          ) : null}
        </Form.Field>
      )
    }
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type={columnData['input type'] === 'NUMERIC' ? 'number' : 'text'}
          name={columnData['input name']}
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createEmailField(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type="email"
          name={columnData['input name']}
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createCheckBox(columnData) {
    register({ name: columnData['input name'], value: false })

    return (
      <Form.Field>
        <Checkbox
          label={t(columnData['header name'] || columnData['input name'])}
          name={columnData['input name']}
          onChange={(e, { name, checked }) => {
            setValue(name, checked)
          }}
        />
      </Form.Field>
    )
  }
  function createDatePicker(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type="date"
          name="date"
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createSelectField(columnData) {
    let options = []
    if (columnData['input name id'] === 'groupId') {
      return <option>dgdg</option>
    }
    if (columnData['input name id'] === 'sfdaCompanyActivity') {
      return (
        <Form.Field error={errors[columnData['input name']]}>
          <strong>
            <IntelMsg id={columnData['label ID']} />
          </strong>
          <Dropdown
            name={columnData['input name']}
            placeholder="Select company activity"
            fluid
            selection
            ref={(ref) => {
              register(ref, {
                validate: { isValidSelect: (value) => value !== '-1' },
              })
              companyActivities.text = ref
            }}
            options={companyActivities}
            onChange={(e, data) => {
              setSelectedActivity(data.value)
              setActivityIsEmpty(false)
            }}
          ></Dropdown>
          {columnData['validator type'] !== 'noValidation' ? (
            <small style={{ color: 'red' }}>
              {errors[columnData['input name']] ? (
                <IntelMsg id={columnData['err msg']} />
              ) : (
                '**'
              )}
            </small>
          ) : null}
        </Form.Field>
      )
    }
    if (columnData['input name id'] === 'countryName') options = []
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <select
          ref={register({
            validate: { isValidSelect: (value) => value !== '-1' },
          })}
          name={columnData['input name']}
        >
          <option value={-1}>{t(columnData.placeholder)}</option>
          {options}
        </select>
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }

  function createTextArea(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <textarea
          ref={register({ validate })}
          name={columnData['input name']}
          rows={3}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  const sorting = (config1, config2) => {
    if (config1.sort < config2.sort) {
      return -1
    }
    if (config1.sort > config2.sort) {
      return 1
    }
    // a must be equal to b
    return 0
  }
  function createColumn(columnData) {
    console.log('input type', columnData['input type'])
    if (columnData['input type'] === 'STRING')
      return createTextField(columnData)
    if (columnData['input type'] === 'EMAIL')
      return createEmailField(columnData)
    if (columnData['input type'] === 'SELECT')
      return createSelectField(columnData)
    if (columnData['input type'] === 'TEXT_AREA')
      return createTextArea(columnData)
    if (columnData['input type'] === 'BOOLEAN') {
      return createCheckBox(columnData)
    }
    if (
      columnData['input type'] === 'HIJRI' ||
      columnData['input type'] === 'DATE'
    ) {
      return createDatePicker(columnData)
    }
    return createTextField(columnData)
  }
  const getDialogContent = (success, msg) => {
    if (success) {
      return (
        <>
          <Icon name="check" size="huge" color="green" />
          <div style={{ fontSize: 'x-large' }}>{msg}</div>
        </>
      )
    }
    return (
      <>
        <Icon name="exclamation triangle" size="huge" color="red" />
        <div style={{ fontSize: 'x-large' }}>{msg}</div>
      </>
    )
  }
  // useEffect(() => {
  //   if (refreshCustomerList) {
  //     GetUserCustomers(email, productName).then((data) => {
  //       console.log('dataa', data)
  //       setCustomerList(data)
  //     })
  //   }
  // }, [refreshCustomerList])
  async function onSubmit(data) {
    console.log('form data', data)
    let content = <></>
    clearErrors()
    const finalData = data
    finalData.sfdaCompanyActivity = selectedActivity
    if (selectedCustomer === 'SFDA Company') {
      if (!activityIsEmpty) {
        content = getDialogContent(true, 'Company Activity is Missing')
        setDialogContent(content)
        setShowStatusDialog(true)
      } else {
        try {
          const response = await saveCustomer(
            productName,
            userEmail,
            finalData,
            selectedCustomer,
          )
          if (response.success) {
            // setRefresh(true)
            content = getDialogContent(
              true,
              response.message ? response.message : 'Customer Added',
            )
            setDialogContent(content)
            setShowStatusDialog(true)
            setShow(false)
            dispatch(RefreshUserCustomersList(true))

            setCreationData([])
          } else {
            // setRefresh(true)
            let { msg } = response
            msg = Array.isArray(msg)
              ? msg.map((error) => <div>{error}</div>)
              : msg
            content = getDialogContent(false, msg || 'Customer Added')
            setDialogContent(content)
            setShowStatusDialog(true)
            dispatch(RefreshUserCustomersList(true))
          }
        } catch (e) {
          let { msg } = e
          msg = Array.isArray(msg)
            ? msg.map((error) => (
                <>
                  <div>{error}</div>
                  <br />
                </>
              ))
            : msg
          setDialogContent(getDialogContent(false, msg || 'Customer Not Added'))
          setShowStatusDialog(true)
          setShow(false)
        }
      }
    }

    try {
      const response = await saveCustomer(
        productName,
        userEmail,
        finalData,
        selectedCustomer,
      )
      if (response.success) {
        // setRefresh(true)
        content = getDialogContent(
          true,
          response.message ? response.message : 'Customer Added',
        )
        setDialogContent(content)
        setShowStatusDialog(true)
        setShow(false)
        dispatch(RefreshUserCustomersList(true))

        setCreationData([])
      } else {
        // setRefresh(true)
        let { msg } = response
        msg = Array.isArray(msg) ? msg.map((error) => <div>{error}</div>) : msg
        content = getDialogContent(false, msg || 'Customer Added')
        setDialogContent(content)
        setShowStatusDialog(true)
        dispatch(RefreshUserCustomersList(true))
      }
    } catch (e) {
      let { msg } = e
      msg = Array.isArray(msg)
        ? msg.map((error) => (
            <>
              <div>{error}</div>
              <br />
            </>
          ))
        : msg
      setDialogContent(getDialogContent(false, msg || 'Customer Not Added'))
      setShowStatusDialog(true)
      setShow(false)
    }
  }
  return (
    <>
      <div>
        <Modal
          onClose={() => setShow(false)}
          onOpen={() => setShow(true)}
          open={show}
          centered
          style={{ position: 'relative', height: 'auto' }}
        >
          <Modal.Header className={styles.header} closeButton>
            <IntelMsg id="addCustomerHeaderModal" />
          </Modal.Header>
          <Modal.Content scrolling style={{ height: '70%' }}>
            <Form
              id="customerAddForm"
              onSubmit={handleSubmit(onSubmit)}
              widths="equal"
            >
              <FormField error={errors.customerTypes}>
                {productName === 'cold' && (
                  <strong>
                    <IntelMsg id="Customer Type" />
                  </strong>
                )}
                {show && productName === 'tank' ? null : (
                  <Dropdown
                    name="customerType"
                    className="my-className"
                    options={customerTypes}
                    placeholder="Select Customer"
                    fluid
                    search
                    selection
                    onChange={async (e, data) => {
                      setDisableSubmit(false)
                      console.log('e.target.value', data.value)
                      setSelectedCustomer(data.value)
                      GetSFDCustomerTemplate(data.value, productName).then(
                        (configData) => {
                          if (configData['sfda attributes map']) {
                            const creationMap = JSON.parse(
                              configData['sfda attributes map'],
                            )
                            creationMap.sort(sorting)
                            setCreationData([])
                            setCreationData(creationMap)
                          }
                          if (configData['default attributes map']) {
                            const defaultCreationMap = JSON.parse(
                              configData['default attributes map'],
                            )
                            defaultCreationMap.sort(sorting)
                            setCreationData([])
                            setCreationData(defaultCreationMap)
                          }
                        },
                      )
                    }}
                    onSelect={(value) => console.log('selected!', value)} // always fires once a selection happens even if there is no change
                    onClose={(closedBySelection) =>
                      console.log('closedBySelection?:', closedBySelection)
                    }
                  ></Dropdown>
                )}
              </FormField>
              {creationData.map((rowData) => (
                <Form.Group>
                  {rowData.data.map((columnData) => createColumn(columnData))}
                </Form.Group>
              ))}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              type="submit"
              disabled={disableSubmit && productName === 'cold'}
              form="customerAddForm"
              className={styles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
            <Button
              className={styles.negativeStatus}
              onClick={() => {
                handleClose()
              }}
            >
              <IntelMsg id="closeBtn" />
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Customer" />}
        dialogContent={dialogContent}
      />
    </>
  )
}
AddCustomer.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default AddCustomer
